angular.module('env.data.rest.model.representationModel', [])

    .factory('RepresentationModel', function ($log, $q, $injector, RepresentationModelFieldTypes) {

        /**
         * Representation (client-side) model
         * @param {ModelDefinition} modelDefinition model definition
         * @param {Object} [proto] plain prototype of new model
         * @constructor
         */
        function RepresentationModel(modelDefinition, proto) {

            var _this = this;
            var rest = $injector.get("rest", "RepresentationModel");

            /**
             * Model Definition
             * @type {ModelDefinition}
             */
            var definition;

            /**
             * Server-side original model. Do not change this model!
             * @type {Object}
             */
            var serverObject;

            /**
             * Clean(non-changed) client-side object
             * @type {Object}
             */
            var originalModel;

            /**
             * Current state of representation model
             * @type {Object}
             */
            var clientModel;

            constructor();

            function constructor() {
                definition = modelDefinition;
                clientModel = modelDefinition.newModel(); // basic init
                originalModel = {};
                serverObject = {};

                initProto();
                initCustomMethods();

                function initProto() {
                    if (proto) {
                        _.forEach(modelDefinition.getFields(), function (fieldDef) {
                            if (!fieldDef.subResource) {
                                clientModel[fieldDef.name] = _.clone(proto[fieldDef.name]);
                            }
                        });
                    }
                }

                function initCustomMethods() {
                    _.forEach(definition.getMethods(), function (method, methodName) {
                        if (!_this[methodName]) {
                            var localMethod = method;
                            _this[methodName] = function () {
                                return localMethod(rest, _this);
                            }
                        } else {
                            $log.warn(_.str.sprintf("Can't init custom method %s. Check %s model definition", methodName, definition.getType()));
                        }
                    })
                }
            }

            /**
             * Async initialization of model (with sub resources initialization)
             * @param {Object} [dtoObject] server-side object
             * @returns {!Promise.<RepresentationModel>} promise of current model
             */
            function initAsync(dtoObject) {
                serverObject = dtoObject;
                var promises = [];
                _.forEach(_.sortBy(modelDefinition.getFields(), "subResource"), function (fieldDef) {
                    promises.push(initFieldAsync(fieldDef));
                });
                return $q.all(promises).then(function () {
                    originalModel = _.clone(clientModel);
                    return _this;
                });
            }

            /**
             * Async initialization of model field
             * @param {FieldDefinition} fieldDefinition field definition
             * @returns {!Promise.<Object>} promise of initialized field
             */
            function initFieldAsync(fieldDefinition) {
                var deferred = $q.defer();
                if (fieldDefinition.subResource) {
                    var init = fieldDefinition.get(rest, _this, serverObject, fieldDefinition);
                    if (init && _.isPromise(init)) {
                        init.then(
                            function (subResource) {
                                deferred.resolve(setField(fieldDefinition, subResource));
                            },
                            function (err) {
                                deferred.reject(err);
                            });
                    } else if (init && _.isFunction(init)) {
                        deferred.resolve(fieldDefinition, setField(fieldDefinition, init()));
                    } else {
                        deferred.resolve(fieldDefinition, setField(fieldDefinition, init));
                    }
                } else {
                    if (serverObject) {
                        setField(fieldDefinition, serverObject[fieldDefinition.serverName]);
                    }
                    deferred.resolve(clientModel[fieldDefinition.name]);
                }

                return deferred.promise;
            }

            function saveAndTransform() {
                var promises = [];
                _.forEach(modelDefinition.getFields(), function (fieldDef) {
                    if (fieldDef.save) {
                        var p = fieldDef.save(rest, _this);
                        if (p && _.isPromise(p)) {
                            promises.push(p)
                        }
                    }
                });

                return $q.all(promises).then(
                    function (resp) {
                        buildOriginalModel();
                        toServerModel();
                        return serverObject;
                    }
                );
            }

            function buildOriginalModel() {
                _.clearObject(originalModel);
                _.forEach(modelDefinition.getFields(), function (fieldDef) {
                    if (!fieldDef.subResource) {
                        originalModel[fieldDef.serverName] = clientModel[fieldDef.name];
                    }
                });
                return originalModel;
            }

            /**
             * Transform representation model to server-side model
             * @returns {Object} copy of server-side model
             */
            function toServerModel() {
                serverObject = serverObject || {};
                var newServerObject = _.clone(serverObject);

                _.forEach(modelDefinition.getFields(), function (fieldDef) {
                    if (!fieldDef.subResource) {
                        newServerObject[fieldDef.serverName] = encode(fieldDef, clientModel[fieldDef.name]);
                    }
                });
                _.resetObject(serverObject, newServerObject);
                return serverObject;
            }

            /**
             * Set field of the model
             * @param {FieldDefinition} fieldDefinition field definition
             * @param {*} [value] server object field value
             * @returns {*} field of the model
             */
            function setField(fieldDefinition, value) {
                clientModel[fieldDefinition.name] = decode(fieldDefinition, value);
                return clientModel[fieldDefinition.name];
            }

            function encode(fieldDefinition, value) {
                var encodedValue;
                var type = fieldDefinition.type;

                try {
                    if (type == RepresentationModelFieldTypes.DYNAMIC) {
                        encodedValue = _.clone(value);
                    } else if (type == RepresentationModelFieldTypes.FLOAT) {
                        encodedValue = _.clone(value);
                    } else if (type == RepresentationModelFieldTypes.INTEGER) {
                        encodedValue = _.clone(value);
                    } else if (type == RepresentationModelFieldTypes.STRING) {
                        encodedValue = _.clone(value);
                    } else if (type == RepresentationModelFieldTypes.BOOLEAN) {
                        encodedValue = _.clone(value);
                    } else if (type == RepresentationModelFieldTypes.DATE) {
                        if (value && _.isDate(value)) {
                            encodedValue = value.toISOString();
                        } else {
                            encodedValue = _.clone(value);
                        }
                    } else if (type == RepresentationModelFieldTypes.ARRAY) {
                        encodedValue = _.clone(value);
                    } else if (type == RepresentationModelFieldTypes.MODEL) {
                        encodedValue = value;
                    }
                } catch (error) {
                    $log.warn(_.str.sprintf("Encode of field was crashed. Model type: %s; Field name: %s; Server value: %s", getType(), fieldDefinition.name, value), error);
                    encodedValue = null;
                }

                if (fieldDefinition.encode) {
                    try {
                        return fieldDefinition.encode(_.clone(value), _.clone(encodedValue), _this, rest);
                    } catch (error) {
                        $log.warn(_.str.sprintf("Custom encode function was crashed. Model type: %s; Field name: %s; Server value: %s", getType(), fieldDefinition.name, value), error);
                    }
                }
                return encodedValue;
            }

            function decode(fieldDefinition, value) {
                var decodedValue;
                var type = fieldDefinition.type;

                try {
                    if (type == RepresentationModelFieldTypes.DYNAMIC) {
                        decodedValue = _.clone(value);
                    } else if (type == RepresentationModelFieldTypes.FLOAT) {
                        decodedValue = parseFloat(value);
                    } else if (type == RepresentationModelFieldTypes.INTEGER) {
                        decodedValue = parseInt(value);
                    } else if (type == RepresentationModelFieldTypes.STRING) {
                        decodedValue = value ? value.toString() : null;
                    } else if (type == RepresentationModelFieldTypes.BOOLEAN) {
                        decodedValue = !!(value && (value == true || value.toLowerCase() == "true" || value == "1" || value.toLowerCase() == "yes"));
                    } else if (type == RepresentationModelFieldTypes.DATE) {
                        if (value) {
                            if (_.isString(value)) {
                                try {
                                    if (value.indexOf('Z') < 0) { // anyway we support only ISO strings
                                        decodedValue = new Date(value + 'Z');
                                    } else {
                                        decodedValue = new Date(value);
                                    }
                                } catch (error) {
                                    $log.warn(_.str.sprintf(
                                            "Incorrect date format in server object. Model type: %s; Field name: %s; Server value: %s",
                                            getType(),
                                            fieldDefinition.name,
                                            value),
                                        error);
                                }
                            } else if (_.isDate(value)) {
                                decodedValue = value;
                            } else {
                                $log.warn(_.str.sprintf(
                                    "Incorrect date format in server object. Model type: %s; Field name: %s; Server value: %s",
                                    getType(),
                                    fieldDefinition.name,
                                    value));
                            }
                        }
                    } else if (type == RepresentationModelFieldTypes.ARRAY) {
                        decodedValue = (!value || !_.isArray(value)) ? [] : _.clone(value);
                    } else if (type == RepresentationModelFieldTypes.MODEL) {
                        decodedValue = value;
                    }
                } catch (error) {
                    $log.warn(_.str.sprintf("Decoding of field was crashed. Model type: %s; Field name: %s; Server value: %s", getType(), fieldDefinition.name, value), error);
                    decodedValue = null;
                }

                if (fieldDefinition.decode) {
                    try {
                        return fieldDefinition.decode(_.clone(value), _.clone(decodedValue), _this, rest);
                    } catch (error) {
                        $log.warn(_.str.sprintf("Custom decode function was crashed. Model type: %s; Field name: %s; Server value: %s", getType(), fieldDefinition.name, value), error);
                    }
                }
                return decodedValue;
            }

            /**
             * Get model type
             * @returns {string}
             */
            function getType() {
                return definition.getType();
            }

            /**
             * Get model definition
             * @returns {ModelDefinition}
             */
            function getDefinition() {
                return definition;
            }

            /**
             * Get model ID
             * @returns {string}
             */
            function getId() {
                return clientModel[definition.getIdPropertyName()];
            }

            /**
             * Get original version of server-side model, if exists
             * @returns {*}
             */
            function getServerModel() {
                return !serverObject ? null : _.clone(serverObject);
            }

            /**
             * Get original client-side model
             * @returns {*}
             */
            function getOriginalModel() {
                return _.clone(originalModel);
            }

            /**
             * Reset changes
             */
            function reset() {
                _.forEach(modelDefinition.getFields(), function (fieldDef) {
                    if (!fieldDef.subResource) {
                        clientModel[fieldDef.name] = originalModel[fieldDef.name];
                    }
                });
            }

            /**
             * Check model is modified
             */
            function isDirty() {
                return _.any(modelDefinition.getFields(), function (fieldDef) {
                    return !fieldDef.subResource && !_.isEqual(originalModel[fieldDef.name], clientModel[fieldDef.name]);
                });
            }

            /**
             * Check model is new (created on client-side and not saved yet)
             */
            function isNew() {
                return !serverObject;
            }

            /**
             * Validate model
             * @returns {Array} Array of the validation errors
             */
            function validate() {
                return []; // todo
            }

            /**
             * Is model valid. Note, that this function executes full validation cycle
             * @returns {boolean}
             */
            function isValid() {
                return true; // todo
            }

            /**
             * Validate field
             * @param {string} fieldName name of the field
             * @returns {Array} Array of the validation errors
             */
            function validateField(fieldName) {
                return []; // todo
            }

            /**
             * Full unRest clone of current model. Result will contain plain objects tree only
             * @returns {Object}
             */
            function unRestClone() {
                return plainCloneRecursive(clientModel, {});
            }

            /**
             * Recursive unRest cloning function
             * @param {Array|Object} original original object
             * @param {Array|Object} target destination object
             * @returns {Array|Object} target object
             */
            function plainCloneRecursive(original, target) {
                _.forEach(original, function (value, key) {
                    if (value && _.isArray(value)) {
                        target[key] = plainCloneRecursive(value, []);
                    } else if (value && value.isRepresentationModel) {
                        target[key] = plainCloneRecursive(value.$model, {});
                    } else {
                        target[key] = _.clone(value);
                    }
                });
                return target;
            }

            var isRepresentationModel = true; // hook for instance detecting

            _.extend(_this, {
                $model: clientModel,

                initAsync: initAsync,
                saveAndTransform: saveAndTransform,

                getType: getType,
                getDefinition: getDefinition,
                getId: getId,
                getServerModel: getServerModel,
                getOriginalModel: getOriginalModel,

                reset: reset,

                isDirty: isDirty,
                isNew: isNew,

                validate: validate,
                isValid: isValid,
                validateField: validateField,

                unRestClone: unRestClone,

                isRepresentationModel: isRepresentationModel
            });

        }

        return (RepresentationModel);
    })

;